import { render, staticRenderFns } from "./four_table.vue?vue&type=template&id=252976b4&"
import script from "./four_table.vue?vue&type=script&lang=js&"
export * from "./four_table.vue?vue&type=script&lang=js&"
import style0 from "./four_table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports